import { useAuth } from './auth-context.js';

/**
 * The laboratory's IANA timezone, from the signed-in session, or `null` while
 * it is loading. Every moment typed at the laboratory (a sample's arrival, a
 * delivery) is read on this clock — never the browser's (UX follow-up,
 * `PROJECT_DOCUMENTATION.md` 15.26).
 */
export function useLaboratoryTimeZone(): string | null {
  return useAuth().user?.tenant?.timezone ?? null;
}
